import { Star, MessageCircle } from "lucide-react";
import { BESTSELLERS, IMAGES } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

const IMG_BY_INDEX = [
  IMAGES.handmade,
  IMAGES.wholesale,
  IMAGES.liquid,
  IMAGES.spray,
];

export const BestSellers = () => {
  const { openGate } = useContact();
  
  return (
    <section
      data-testid="bestsellers-section"
      className="section-pad bg-[#1E3A8A] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 hero-pattern opacity-30 pointer-events-none" />
      <div className="msc-container relative">
        <div className="flex items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 bg-[#F59E0B] text-[#1F2937] px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-wider">
              <Star className="w-3.5 h-3.5" /> Sabse Zyada Bikne Wale
            </span>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Best <span className="text-[#FBBF24]">Sellers</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {BESTSELLERS.map((p, i) => (
            <button
              key={p.name}
              onClick={() => openGate(`Hi, mujhe "${p.name}" ki rate aur availability chahiye.`)}
              data-testid={`bestseller-${i}`}
              className="bg-white text-[#1F2937] rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 flex flex-col text-left w-full"
            >
              <div className="aspect-square bg-gray-100 overflow-hidden w-full">
                <img
                  src={IMAGES[p.imageKey]}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 flex flex-col justify-between flex-1 w-full">
                <div>
                  <h3 className="font-display font-bold text-sm sm:text-base leading-tight">
                    {p.name}
                  </h3>
                  <p className="text-xs text-[#4B5563] mt-1">{p.note}</p>
                </div>
                <div className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold text-[#25D366]">
                  <MessageCircle className="w-3.5 h-3.5" /> {p.price}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
